export default [
  {
    content: "안전인증(’09.07.01.이후) 및 안전검사 수검 여부 확인\n※ 차량탑재형 고소작업대 안전검사제도 ’16.8.18. 시행",
    isChecked: "",
    title: "공통사항",
  },
  {
    content: "추락방지용 개인보호구 안전모, 안전대 지급 및 착용",
    isChecked: "",
    title: "공통사항",
  },
  {
    content: "작업대의 안전난간 설치 상태 확인",
    isChecked: "",
    title: "공통사항",
  },
  {
    content: "정격하중 초과 시 과부하방지장치 정상작동 확인",
    isChecked: "",
    title: "공통사항",
  },
  {
    content: "비상정지장치 정상작동 확인",
    isChecked: "",
    title: "공통사항",
  },
  {
    content: "붐길이, 각도 센서 정상 작동 확인",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "붐 길이에 따른 하중 및 허용작업 반경 정상 설정 확인",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "붐 상승 시 아웃트리거 작동 방지 인터록 확인",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "붐대 용접부 균열 없고 턴테이블 볼트 체결 상태 확인",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "붐 인출 와이어 로프 또는 체인 마모 상태 양호 확인",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "과상승방지장치 설치 상태 및 정상 작동 확인",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "작업대 작동 경보장치 정상 동작 확인",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "제어장치는 우발 동작이 방지되는 연동구조로 설치",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "풋스위치 미끄럼방지 표면 상태 확인 및 제어 연동 해제 사용 금지",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "유압계통 이상 시 작업대 낙하방지 밸브 설치 여부 확인",
    isChecked: "",
    title: "시저형",
  },
];
